import React, {FC} from 'react';
import classNames from 'classnames';
import {BG} from 'constants/index';
import {motion} from 'framer-motion';

import * as styles from './styles.module.scss';

type ScrollSlowlyProps = {
	bg?: BG
	classNames?: {
		panel?: string
		scroll?: string
	}
	title?: React.ReactNode
	children: React.ReactNode[]
}

export const ScrollSlowly: FC<ScrollSlowlyProps> = ({
	bg = BG.transparent,
	classNames: cn,
	title,
	children
}) => {
	const motionProps = {
		className: styles.motion,

		animate: {
			x: '-50%',
		},

		transition: {
			duration: 60,
			ease: 'linear',
			repeat: Infinity,
		}
	};

	return (
		<div className={classNames({
			[styles.wrapper]: true,
			[styles.light]: bg === BG.light,
			[styles.dark]: bg === BG.dark,
		})}>
			<div className={classNames(styles.panel, cn?.panel)}>
				{/* [z-index: 3] top layer */}
				<div className={styles.title}>
					{title}
				</div>

				{/* [z-index: 1] bottom layer */}
				<div className={styles.items}>
					{/* [position: absolute] animated sliding components */}
					<motion.div {...motionProps}>
						<div className={cn?.scroll}>
							{children}
							{children}
							{children}
							{children}
							<div />
						</div>
					</motion.div>

					{/* [position: static] empty div to force container height */}
					<div className={classNames(cn?.scroll)}>
						<div />
					</div>
				</div>

				{/* [z-index: 1] middle layer (fade effect) */}
				<div className={classNames({
					[styles.fades]: true,
					[styles.light]: bg === BG.light,
					[styles.dark]: bg === BG.dark,
				})}>
					<div className={styles.fadeLeft} />
					<div className={styles.fadeRight} />
				</div>
			</div>
		</div>
	);
};
